import styles from './style.module.css';
import imageLoading from '../../assets/images/logo-light.png';

export function Loading() {
  return (
    <div className={styles.loading}>
      <img className={styles.heartbeat} src={imageLoading} alt="Logo loading" />
    </div>
  );
}
